import { add, format } from 'date-fns'
import { CreateLeaveDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

export const useCreateLeave: OneCreationActionResolver = () => {
  const { employee } = useCurrentSession()

  const [createLeave, { loading }] = useMutation(CreateLeaveDocument, {
    extractorFn: (data) => data.timeoffMutations.createTimeoffLeave,
    errorPolicy: 'all',
  })

  const createLeaveHandler = async (args: {
    startOn: string
    duration: number
    leaveType: { id: string }
  }) => {
    if (!employee) {
      return
    }

    const {
      startOn,
      duration,
      leaveType,
    }: { startOn: string; duration: number; leaveType: { id: string } } = args

    const startOnDate = new Date(startOn)
    const finishOn = add(startOnDate, { days: duration - 1 })

    const result = await createLeave({
      variables: {
        employeeId: employee.id,
        startOn: format(startOnDate, 'yyyy-MM-dd'),
        finishOn: format(finishOn, 'yyyy-MM-dd'),
        leaveTypeId: leaveType.id,
      },
    })

    return handleResult(result, (_errors) => {})
  }

  return {
    resolver: createLeaveHandler,
    loading,
  }
}
